$(function () {
  'use strict';

  var $window = $(window);
  var $document = $(document);
  var $navigation = $('#navigation');

  // Early exit
  if(!$navigation.length) return;

  var $items = $navigation.find('.js-navigation-item');
  var need_subitems = !$navigation[0].hasAttribute('aria-hidden');
  var has_resize = false;

  var mount = function ($item) {
    var $link = $item.find('.js-navigation-link');
    $link.attr('aria-haspopup', "true");
    $link.attr('aria-expanded', "false");

    $item.on("mouseover", function () {
      $link.attr('aria-expanded', "true");
    });

    $item.on("mouseout", function () {
      $link.attr('aria-expanded', "false");
    });

    $link.on("keypress", function (event) {
      event.preventDefault();

      if(event.keyCode == 32) {
        $link.attr('aria-expanded', $link.attr('aria-expanded') == "true" ? "false" : "true");
      }
    });

    $document.on("focusin", function (event) {
      if($link.attr("aria-expanded") == "true" && $item.has(document.activeElement).length == 0) {
        $link.attr('aria-expanded', "false");
      }
    });
  };

  var unmount = function ($item) {
    var $link = $item.find('.js-navigation-link');
    $link.removeAttr('aria-haspopup');
    $link.removeAttr('aria-expanded');
    $item.off("mouseover mouseout");
    $link.off("keypress");
    $document.off("focusin");
  };

  var update = function () {
    if(has_resize && tmp != need_subitems) {
      var tmp = !$navigation[0].hasAttribute('aria-hidden');
      if(tmp != need_subitems) {
        if(tmp) {
          $items.each(function (index, item) {
            mount($(item));
          });
        } else {
          $items.each(function (index, item) {
            unmount($(item));
          });
        }
      }

      need_subitems = tmp;
    }

    has_resize = false;
    window.requestAnimationFrame(update);
  };

  $window.on("resize", function () {
    has_resize = true;
  });

  var init = function () {
    if(need_subitems) {
      $items.each(function (index, item) {
        mount($(item));
      });
    }

    update();
  };

  init();
});
